<template>
  <div>
    <div class="deviceManagement">
      <CommonForm
        :form="form"
        :searchItems="searchItems"
        @search="handleSearchChange"
        @clear="clear"
        @taskTypeChange="taskTypeChange"
      />
      <!-- <div class="operate-box">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="showUpload = true"
        >
          导入
        </el-button>
        <el-button icon="el-icon-download" size="small" @click="handleExport">
          下载
        </el-button>
      </div> -->
      <CommonTable
        ref="listRef"
        v-loading="loading"
        :columns="columns"
        :tableData="tableData"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template v-slot:videoUrl="{ row }">
          <el-button
            type="text"
            size="small"
            @click="handleVideo(row)"
            v-if="row.videoUrl"
          >
            预览
          </el-button>
          <span v-else>--</span>
        </template>

        <template v-slot:actions="{ row }">
          <el-button type="text" size="small" @click="tableEdit(row)">
            问题描述
          </el-button>
        </template>
      </CommonTable>

      <VideoDialog ref="videoRef" />
      <CommonDrawer
        ref="Drawer"
        :form="drawerForm"
        :formItems="formItems"
        title="用户反馈"
        @submit="submitDrawer"
      />
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable";
import CommonForm from "@/components/CommonForm";
import VideoDialog from "@/components/VideoDialog";
import CommonDrawer from "@/components/el-drawer";

import { FEEDBACK_TYPE, FEEDBACK_STATUS } from "@/constants/index";
import { getFeedbackList, getTypeUser, getFeedbackDetail, changeFeedbackStatus } from "@/api/index";
import dayjs from "dayjs";

export default {
  components: {
    CommonTable,
    CommonForm,
    VideoDialog,
    CommonDrawer,
  },
  data() {
    return {
      columns: [
        // { prop: "userId", label: "用户id" },
        // { prop: "taskId", label: "任务id" },
        { prop: "parentType", label: "反馈类型" },
        { prop: "type", label: "反馈问题" },
        { prop: "time", label: "反馈日期" },
        { prop: "phoneModel", label: "手机型号" },
        { prop: "status", label: "反馈状态" },
        { prop: "content", label: "问题描述" },
        { prop: "result", label: "处理结果" },
        { prop: "videoUrl", label: "视频" },
        { prop: "actions", label: "操作" },
      ],
      tableData: [],
      form: {},
      drawerForm: {},
      imgUrl: "",
      loading: false,
      feedbackTypeList: [],
      feedbackProblemList: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
    };
  },
  computed: {
    searchItems() {
      return [
        {
          type: "select",
          value: "typeParentId",
          label: "反馈类型",
          options: this.feedbackTypeList,
        },
        {
          type: "select",
          value: "typeId",
          label: "反馈问题",
          options: this.feedbackProblemList,
        },
        {
          type: "select",
          value: "status",
          label: "反馈状态",
          options: FEEDBACK_STATUS,
        },
        // {
        //   type: "input",
        //   value: "userId",
        //   label: "用户id",
        // },
        // {
        //   type: "input",
        //   value: "taskId",
        //   label: "任务id",
        // },
      ]
    },
    formItems() {
      return [
        {
          type: "select",
          value: "status",
          label: "进度",
          options: FEEDBACK_STATUS,
        },
        {
          type: "textarea",
          value: "content",
          label: "描述",
        },
      ];
    }
  },
  created(){
    this.getFunUserType();
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 反馈类型改变
    taskTypeChange(id) {
      if(id) {
        this.getFunUserProblem(id)
      } else {
        this.feedbackProblemList = []
      }
    },
    // 提交
    submitDrawer(form) {
      // console.log('提交', form)
      changeFeedbackStatus(form).then(() => {
        this.getData();
      });
    },
    // 问题描述
    tableEdit(row) {
      getFeedbackDetail(row.id).then((res) => {
        // console.log(res.data);
        res.data.content = res.data.result;
        this.drawerForm = res.data;
        this.$refs.Drawer.init()
      });
    },
    // 清除某一个条件出触发搜索
    clear(values) {
      // console.log('请空', values)
      // this.form = values;
      this.getData();
    },
    getData() {
      const { page, size } = this.pagination;
      this.loading = true;
      getFeedbackList({ page, size, ...this.form}).then((res) => {
        const {
          data: { list = [], total },
        } = res;
        this.pagination.total = total;
        this.tableData = list;
        this.loading = false;
      });
    },
    // 用户反馈类型
    getFunUserType() {
      getTypeUser(0).then((res) => {
        // console.log('res.data', res.data.data)
        this.feedbackTypeList = res.data.data.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
      });
    },
    // 用户反馈问题
    getFunUserProblem(id) {
      console.log('反馈问题')
      getTypeUser(id).then((res) => {
        this.feedbackProblemList = res.data.data.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
      });
    },
    // 递归处理数据
    typeFun(children) {
      children.map(item => {
        item.label = item.name
        item.value = item.id
        item.children = item.childList

        if(item.children.length > 0) {
          this.typeFun(item.childList)
        } else {
          delete item.children
        }
      })
      return children
    },
    gotoPage(val) {
      this.pagination.page = val;
      this.getData();
    },
    // 搜索
    handleSearchChange(values) {
      this.form = values;
      this.gotoPage(1);
    },
    // 列表页码切换
    handleTableChange({ page, size }) {
      this.pagination.page = page;
      this.pagination.size = size;
      this.getData();
    },
    // 查看视频
    handleVideo(item) {
      this.$refs.videoRef.init({
        videoUrl: item.videoUrl,
        poster: item.poster,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.deviceManagement {
  .operate-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
}
</style>
